var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ci-color w-100 border border-color-light"
  }, [_c('div', {
    staticClass: "w-100 h-160px h-lg-200px pa-20 pa-md-28",
    style: 'background-color:' + _vm.hex + ';'
  }, [_c('p', {
    staticClass: "page-text--sm font-weight-bold"
  }, [_c('span', {
    class: {
      'color-white': _vm.type == 'dark'
    }
  }, [_vm._v(_vm._s(_vm.tit))])])]), _c('div', {
    staticClass: "pa-20 pa-md-30 py-lg-34 border-top border-color-light helvetica"
  }, [_c('p', {
    staticClass: "page-text--sm font-weight-bold mb-8 mb-lg-14"
  }, [_vm._v(" PANTONE " + _vm._s(_vm.pantone) + " ")]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "page-text--sm min-w-60px mr-lg-14 color-grey-a"
  }, [_vm._v("RGB")]), _c('p', [_vm._v(_vm._s(_vm.rgb))])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "page-text--sm min-w-60px mr-lg-14 color-grey-a"
  }, [_vm._v("CMYK")]), _c('p', [_vm._v(_vm._s(_vm.cmyk))])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "page-text--sm min-w-60px mr-lg-14 color-grey-a"
  }, [_vm._v("HEX")]), _c('p', [_vm._v(_vm._s(_vm.hex))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }